import { FC, Fragment, ReactNode } from 'react';

import { Divider } from 'antd';
import classNames from 'classnames';

import useMobile from '@/hooks/use-mobile';

import styles from './styles.module.scss';

type Props = {
	title: ReactNode;
	size?: 'large' | 'middle';
	actions?: ReactNode[];
	alignDividerMargin?: boolean;
};

export const SectionHeader: FC<Props> = ({
	title,
	size = 'large',
	actions,
	alignDividerMargin,
}) => {
	const { isMobile } = useMobile();

	return (
		<div>
			<div className={styles.content}>
				<div className={classNames(styles.title, size === 'middle' && styles.middleTitle)}>
					{title}
				</div>
				<div className={classNames(styles.actions, { [styles.fullscreenButtons]: !isMobile })}>
					{actions?.map((action, index) => <Fragment key={index}>{action}</Fragment>)}
				</div>
			</div>
			<Divider
				className={classNames(styles.divider, {
					[styles.alignDividerMargin]: alignDividerMargin,
					[styles.mobileDivider]: isMobile,
				})}
			/>
		</div>
	);
};
